// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__kbj0U","name":"Header_name__q677u","birthday":"Header_birthday__2YzfV","skeleton":"Header_skeleton__Fdw5l"};